<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> کلاس های گروهی اتمام یافته‌ی من </template>
    <CustomTable
      v-if="masterFinishedGroupClassList"
      :pageNumber="finishedGroupClassFilters.pageNumber"
      :count="finishedGroupClassFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="masterFinishedGroupClassList"
      @changePage="changePage"
    >
      <template #duration="data">
        {{ calculateDurationByMinute(data.item) }}
        دقیقه
      </template>
      <template #joinedUsers="data">
        {{
          data.item.groupClassStudents && data.item.groupClassStudents.length
            ? `${data.item.groupClassStudents.length} نفر`
            : "-"
        }}
      </template>
      <template #groupClassStatus="data">
        <div class="w-100 d-flex align-items-center justify-content-center">
          <BBadge
            pill
            class="font-weight-normal"
            :variant="
              groupClassPersianStatuses[data.item.groupClassStatus].variant
            "
          >
            {{ groupClassPersianStatuses[data.item.groupClassStatus].title }}
          </BBadge>
        </div>
      </template>
      <template #actions="data">
        <BButton
          variant="transparent"
          size="sm"
          :to="`/master/group-classes/${data.item.id}`"
        >
          <FeatherIcon icon="ExternalLinkIcon" size="23" class="text-primary" />
        </BButton>
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    if (this.computedPageRouteQuery) {
      this.finishedGroupClassFilters.pageNumber = this.computedPageRouteQuery;
    } else {
      this.finishedGroupClassFilters.pageNumber = 1;
    }
    this.getMasterFinishedGroupClassesList();
  },
  data() {
    return {
      isLoading: false,
      finishedGroupClassFilters: {
        pageNumber: 1,
        count: 10,
        from: null,
        to: null,
      },
      masterFinishedGroupClassList: null,
      totalCount: null,
      groupClassPersianStatuses: {
        0: {
          title: "جدید",
          variant: "success",
        },
        1: {
          title: "در انتظار تایید",
          variant: "warning ",
        },
        2: {
          title: "در حال ثبت نام",
          variant: "info",
        },
        3: {
          title: "اتمام ظرفیت",
          variant: "primary",
        },
        4: {
          title: "کنسل شده",
          variant: "danger",
        },
        5: {
          title: "به اتمام رسیده",
          variant: "success",
        },
      },
      tableColumns: [
        {
          key: "groupClassId",
          label: "شناسه",
        },
        {
          key: "groupClassName",
          label: "عنوان کلاس",
        },
        {
          key: "duration",
          label: "مدت زمان کلاس",
        },
        {
          key: "joinedUsers",
          label: "تعداد شرکت کننده ها",
        },
        {
          key: "groupClassStatus",
          label: "وضعیت کلاس",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
          formatter: (value) =>
            `${this.customFullDateConvert(
              value
            )} - ${this.customConvertHourAndMinute(value)}`,
        },
        {
          key: "endDate",
          label: "تاریخ پایان",
          formatter: (value) =>
            `${this.customFullDateConvert(
              value
            )} - ${this.customConvertHourAndMinute(value)}`,
        },

        {
          key: "actions",
          label: "جزئیات",
        },
      ],
    };
  },
  methods: {
    changePage(pageNumber) {
      this.finishedGroupClassFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getMasterFinishedGroupClassesList();
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          finishedGroupClassPageNumber: pageNumber,
        },
      });
    },
    calculateDurationByMinute(groupClass) {
      if (groupClass.startDate && groupClass.endDate) {
        return (
          Math.ceil(
            new Date(groupClass.endDate).getTime() -
              new Date(groupClass.startDate).getTime()
          ) /
          1000 /
          60
        );
      }
    },
    async getMasterFinishedGroupClassesList() {
      try {
        this.isLoading = true;
        const _this = this;
        const getMasterFinishedGroupClasses = new GetMasterFinishedGroupClasses(
          _this
        );
        getMasterFinishedGroupClasses.setRequestParam(
          _this.finishedGroupClassFilters
        );
        await getMasterFinishedGroupClasses.fetch((res) => {
          if (res.isSuccess) {
            _this.masterFinishedGroupClassList = res.data.data;
            _this.totalCount = res.data.total;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.finishedGroupClassPageNumber) {
        return this.$route.query.finishedGroupClassPageNumber;
      }
      return null;
    },
  },
  mixins: [timeConvertUtils],
  components: {
    PageWrapper,
    CustomTable,
    BButton,
    BBadge,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import timeConvertUtils from "@/mixins/timeConvertUtils";
import { BButton, BBadge } from "bootstrap-vue";
import { GetMasterFinishedGroupClasses } from "@/libs/Api/GroupClass";
</script>
